import { fetch } from '@atlassian/eoc-fetch';
import type { PaginationEndpointParams } from '@atlassian/eoc-pagination';

import {
	type RolesResponse,
	type UpdateUserRoleResponse,
	type UserWithRoleResponse,
} from '../../../common/types';
import { URLBuilder } from '../../../common/utils/url-builder';

export const getUsersEndpoint = ({
	lastEvaluatedToken,
	limit,
	queryKey,
}: PaginationEndpointParams) => {
	const [_, query] = queryKey;

	let url = new URLBuilder(`/v1/users/search`)
		.withQueryParam('limit', limit)
		.withQueryParam('query', query)
		.withQueryParam('cursor', lastEvaluatedToken)
		.build();
	return fetch<UserWithRoleResponse>(url);
};

export const getFilteredUsersEndpoint = ({
	lastEvaluatedToken,
	limit,
	queryKey,
}: PaginationEndpointParams) => {
	const [_, ...filters] = queryKey;

	if (filters.length === 0) {
		return Promise.resolve({
			lastEvaluatedToken: '',
			values: [],
		});
	}

	return fetch<UserWithRoleResponse>('/v1/users/roles/filter', {
		method: 'POST',
		body: {
			limit,
			roles: filters,
			offset: lastEvaluatedToken || 0,
		},
	});
};

export const getRolesEndpoint = () => {
	return fetch<RolesResponse>('/v1/users/roles');
};

export const updateRoleOfUserEndpoint = ({
	roleId,
	accountId,
}: {
	roleId: string;
	accountId: string;
}) => {
	return fetch<UpdateUserRoleResponse>(`/v1/users/roles/assign`, {
		method: 'PATCH',
		body: {
			accountId,
			roleId,
		},
	});
};
